module.exports = __webpack_public_path__ + "images/emoji/ideograph_advantage.5101fb2297586dd6c874.png";